import { Dispatch, SetStateAction, useState } from 'react';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button, } from '@mui/material'
import { SupportItem, useUpdateSupportMutation } from '../services/customerSupport';
import { showError, showToast } from '../constants/toasts';

interface AddReplyModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>
    data?: SupportItem | null;
    onSuccess?: () => void;
    fetchCustomerSupport?: () => void
}

export default function AddReply({ open, onClose, setOpen, data, onSuccess, fetchCustomerSupport }: AddReplyModalProps) {
    const [reply, setReply] = useState('');
    const [updateSupport, { isLoading }] = useUpdateSupportMutation();

    const handleSubmit = async () => {
        if (!data?._id) {
            showError('Invalid support id');
            return;
        }
        try {
            await updateSupport({ id: data._id, body: { reply, status: 'APPROVED' } }).unwrap();
            showToast('Reply submitted');
            fetchCustomerSupport && fetchCustomerSupport()
            setOpen(false);
            setReply('');
            onSuccess && onSuccess();
        } catch (e: any) {
            showError(e?.data?.message || 'Failed to submit reply');
        }
    };
    return (
        <Modal
            className="modal addReply_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Add Reply</h2>
                        <div className="btn-close" onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </div>
                    </div>
                    <div className="view_page gap_p">
                        <div className="w_100">
                            <h6>Query Title</h6>
                            <p>{data?.title || '-'}</p>
                        </div>
                        <div className="w_100">
                            <h6>Query Description</h6>
                            <p>{data?.description || '-'}</p>
                        </div>
                    </div>
                    <form className="form" action="">
                        <div className="control_group">
                            <div className="section_title">
                                <h2>Add Reply</h2>
                            </div>
                            <TextField value={reply} onChange={(e) => setReply(e.target.value)} placeholder="Enter Reply" fullWidth hiddenLabel multiline maxRows={5} minRows={5}></TextField>
                        </div>
                        <div className="footer_btn_flex">
                            <Button className="btn btn_grey" onClick={() => setOpen(false)}>Cancel</Button>
                            <Button disabled={isLoading} className="btn btn_primary" onClick={handleSubmit}>Submit</Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal >
    )
}
